import styled, { css } from 'styled-components';
import { Box } from '@awaze/design-system.components.box';
import { pxToRems } from '@awaze/design-system.utils.react';
export const PopoverStyled = styled.div `
  display: flex;
  width: ${({ popoverWidth }) => popoverWidth &&
    (isNaN(Number(popoverWidth)) ? popoverWidth : pxToRems(popoverWidth))};
  &:focus {
    box-shadow: 0 0 0 4px ${({ theme }) => theme.ColorBlackOpacity10};
    outline: none;
    border-radius: ${({ radius }) => pxToRems(radius)};
  }

  // This is to fix hydration errors, and target this directly by classname.
  div.popoverArrowStyled {
    position: absolute;
    width: ${pxToRems(12)};
    height: ${pxToRems(12)};
  }
`;
export const PopoverContainerStyled = styled.div `
  display: ${({ block }) => (block ? 'block' : 'inline-block')};
  position: ${({ relativePosition }) => relativePosition === true ? 'relative' : undefined};
`;
export const PopoverArrowStyled = styled.div `
  position: absolute;
  width: ${pxToRems(12)};
  height: ${pxToRems(12)};
  ${({ placement }) => {
    return placement.includes('bottom')
        ? css `
          top: 0;
          left: 0;
          margin-top: -${pxToRems(6)};
          width: ${pxToRems(12)};
          height: ${pxToRems(6)};
          &::before {
            border-width: 0 ${pxToRems(6)} ${pxToRems(6)} ${pxToRems(6)};
            border-color: transparent transparent #fff transparent;
          }
        `
        : placement.includes('top')
            ? css `
          bottom: 0;
          left: 0;
          margin-bottom: -${pxToRems(12)};
          width: ${pxToRems(12)};
          height: ${pxToRems(6)};
          &::before {
            border-width: ${pxToRems(6)} ${pxToRems(6)} 0 ${pxToRems(6)};
            border-color: #fff transparent transparent transparent;
          }
        `
            : placement.includes('right')
                ? css `
          left: 0;
          margin-left: -${pxToRems(9)};
          height: ${pxToRems(12)};
          width: ${pxToRems(6)};
          &::before {
            border-width: ${pxToRems(6)} ${pxToRems(6)} ${pxToRems(6)} 0;
            border-color: transparent #fff transparent transparent;
          }
        `
                : placement.includes('left')
                    ? css `
          right: 0;
          margin-right: -${pxToRems(9)};
          height: ${pxToRems(12)};
          width: ${pxToRems(6)};
          &::before {
            border-width: ${pxToRems(6)} 0 ${pxToRems(6)} ${pxToRems(6)};
            border-color: transparent transparent transparent #fff;
          }
        `
                    : '';
}}

  &::before {
    content: '';
    margin: auto;
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
  }
`;
export const BoxStyled = styled(Box) `
  position: relative;
  box-shadow: ${({ shadow }) => `0 ${pxToRems(shadow)} ${pxToRems(shadow * 2)} rgba(0, 0, 0, 0.1)`};
  border-radius: ${({ radius }) => pxToRems(radius)};
  width: ${({ boxWidth }) => boxWidth && (isNaN(Number(boxWidth)) ? boxWidth : pxToRems(boxWidth))};
  background-color: ${({ theme }) => theme.ColorWhiteOpacity100};

  ${({ enableHitarea, placement, offset }) => enableHitarea &&
    css `
      &::before {
        content: '';
        display: block;
        position: absolute;

        // Handle vertical placements (top/bottom)
        ${placement?.startsWith('top') &&
        css `
          height: ${`${offset?.top}px` || pxToRems(36)};
          width: 100%;
          top: 100%;
          left: 0;
        `}

        ${(placement?.startsWith('bottom') || placement === undefined) &&
        css `
          height: ${`${offset?.top}px` || pxToRems(36)};
          width: 100%;
          bottom: 100%;
          left: 0;
        `}

        // Handle horizontal placements (left/right)
        ${placement?.startsWith('left') &&
        css `
          width: ${`${offset?.left}px` || pxToRems(36)};
          height: 100%;
          left: 100%;
          top: 0;
        `}

        ${placement?.startsWith('right') &&
        css `
          width: ${`${offset?.left}px` || pxToRems(36)};
          height: 100%;
          right: 100%;
          top: 0;
        `}
      }
    `}
`;
//# sourceMappingURL=popover.styles.js.map